<template>
  <fragment>
    <tr>
      <td>
        <strong>Dias disponíveis para o vencimento</strong>
      </td>
      <td>
        <input-field
          placeholder="Dias separados por vírgula"
          v-model="form.get('dueDays').value"
          :errors="form.get('dueDays').errors"
          @input="emitFormFieldChanged('dueDays')"
          :disabled="disabledForm"
        />
      </td>
    </tr>

    <tr>
      <td>
        <strong>Aluno pode alterar dia de vencimento</strong>
      </td>
      <td>
        <select-field
          :options="commomTypes"
          v-model="form.get('studentCanChangeDueDay').value"
          :errors="form.get('studentCanChangeDueDay').errors"
          @input="emitFormFieldChanged('studentCanChangeDueDay')"
          :disabled="disabledForm"
        />
      </td>
    </tr>
  </fragment>
</template>
<script>
import { InputField, SelectField } from 'components/form';

export default {
  components: {
    InputField,
    SelectField,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    disabledForm: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      commomTypes: [
        { value: true, label: 'Sim' },
        { value: false, label: 'Não' },
      ],
    };
  },
  methods: {
    emitFormFieldChanged(field) {
      this.$emit('form-field-changed', { [field]: this.form.get(field).value });
    },
  },
};
</script>
